import ContentType from '@/helpers/contentType';
import CategoryType from '@/helpers/contentCategory';
import { PROCESSING_STATUS } from '@/helpers/avaliaActivity';

import ValidateTopicConfigurations from '@/mixins/validateTopicConfigurations';

export default {
  mixins : [ValidateTopicConfigurations],
  props  : {
    topic: {
      type    : Object,
      default : () => ({})
    },
    isOpenOnBottomSheet: {
      type    : Boolean,
      default : false
    },
    isStudent: {
      type    : Boolean,
      default : false
    }
  },
  data() {
    return {
      hasEllipsisOnTitle       : false,
      hasEllipsisOnDescription : false,
      showMore                 : false,
      hasExpanded              : false,
      categoryType             : CategoryType
    };
  },
  computed: {
    showHasExpandedButton() {
      return !this.hasExpanded && this.isOpenOnBottomSheet &&
        (
          (this.topic.topicTypeId === ContentType.PAGE && this.topic.children && this.topic.children.length) ||
          (this.topic.topicTypeId === ContentType.WEBCONFERENCE) ||
          (this.topic.content && this.topic.content.description)
        );
    },
    showSubtitleInfos() {
      if (this.isStudent && this.topic.topicTypeId === ContentType.AVALIA && (!this.topic.content?.isActive || this.topic.content.status !== PROCESSING_STATUS.OK)) {
        return false;
      }
      return (
        (this.topic.hasDeadline && this.topic.deadlineAt)
        || (this.topic.categoryTypeId === CategoryType.WEBCONFERENCE && this.topic.content.endAt)
        || (this.topic.hasGrade && this.topic.grade.value !== null)
      );
    },
    showRetriesLink() {
      if (this.isAvaliaExternalActivity(this.topic)) {
        return this.topicHasRetries(this.topic);
      }
      if (this.topic.categoryTypeId === CategoryType.SCORM) {
        return !!this.topic.content.studentCurrentAttempt;
      }
      return false;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.topic && this.topic.title) {
        this.hasEllipsisOnTitle = this.$refs.title.clientHeight < this.$refs.title.scrollHeight;
      }

      if (this.mustShownDescription()) {
        this.hasEllipsisOnDescription = this.$refs.description.clientHeight < this.$refs.description.scrollHeight;
      }
    });
  },
  methods: {
    isClosed(topic) {
      if (topic.categoryTypeId === CategoryType.WEBCONFERENCE && topic.content?.hasEnded) {
        return this.$t('content.layout.streaming.cardTopic.deadlineEnd');
      } else {
        return this.$t('content.layout.streaming.cardTopic.deadline');
      }
    },
    openAvaliaActivityResults(event, topic) {
      if (this.avaliaActivityAttemptsIsLinkEnabled(topic)) {
        event.stopPropagation();

        this.$emit('openAvaliaActivityResults', topic);
      }
    },
    mustShownDescription() {
      return (this.topic.content && this.topic.content.description)
        || (this.isAvaliaExternalActivity(this.topic) && this.topic.content && this.topic.content.html);
    },
    handleRetriesLinkClick(event) {
      if (this.isAvaliaExternalActivity(this.topic) && this.avaliaActivityAttemptsIsLinkEnabled(this.topic)) {
        event.stopPropagation();
        this.$emit('openAvaliaActivityResults', this.topic);
      }
      if (this.topic.categoryTypeId === CategoryType.SCORM) {
        this.$nuxt.$emit('changeIsOpenModalTopicDetail', {
          topic: this.topic
        });
      }
    }
  }
};
